// @flow

import { clientSearchActions } from './clientSearchActionCreator';

const initialState = {
  searchInput: '',
  isFetching: false,
  clientList: []
};

export default function(state: Object = initialState, action: Object) {
  switch (action.type) {
    case clientSearchActions.SET_CLIENT_LIST:
      return { ...state, clientList: action.payload };

    case clientSearchActions.SET_IS_FETCHING_CLIENT_LIST:
      return { ...state, isFetching: action.payload };

    case clientSearchActions.SET_CLIENT_SEARCH_INPUT:
      return { ...state, searchInput: action.payload };

    case clientSearchActions.RESET_CLIENT_LIST_AND_FETCHING:
      return { ...state, isFetching: false, clientList: [] };

    default:
      return state;
  }
}

export const getClientList = state => state.clientSearch.clientList;

export const getIsFetchingClients = state => state.clientSearch.isFetching;

export const getClientSearchInput = state => state.clientSearch.searchInput;
